import { FecAccountMappingStatus } from '../enums/fecAccountMappingStatus'
import { FecAccountMatchType } from '../enums/fecAccountMatchType'

export const getFecAccountMappingStatus = (
  existsInBilly: boolean | undefined,
  matchType: FecAccountMatchType,
): FecAccountMappingStatus => {
  if (typeof existsInBilly === 'boolean') {
    return existsInBilly ? FecAccountMappingStatus.Existing : FecAccountMappingStatus.New
  }

  if (matchType === FecAccountMatchType.SubAccount || matchType === FecAccountMatchType.Unknown) {
    return FecAccountMappingStatus.New
  }

  return FecAccountMappingStatus.Existing
}
